import { BaseComponent } from '../../base-component';
import { HtmlOffersPageLinkReplacer } from './html-offers-page-link-replacer';
import { ArticleOptionsServices } from '../../global';
import { BenefitPrice } from '../types';
import { ActiveBenefits } from './active-benefits';
import { EventCallback } from '@otto-ec/global-resources/event-q-bus';
import { benefitEvents } from '@otto-ec/nexus-registry/benefit/events';
import { Unset } from '@otto-ec/global-resources/nexus';

export class CompetingOffersComponent extends BaseComponent {
    public rootSelector = '.js_pdp_competing-offers';

    private readonly ARTICLE_OPTIONS_CHANGED_EVENT = 'ft5.pdp.articleOptionsChanged';
    private readonly ARTICLE_OPTIONS_RECEIVE_SERVICE_INFORMATION_EVENT = 'ft5.articleoptions.receiveServiceInformation';

    private articleOptionsEventListener?: EventCallback<[]> | null;
    private benefitsEventUnset?: Unset | null;
    private activeBenefits: ActiveBenefits;
    private htmlOffersPageLinkReplacer: HtmlOffersPageLinkReplacer;

    constructor() {
        super();
        this.htmlOffersPageLinkReplacer = new HtmlOffersPageLinkReplacer(this.rootSelector);
        this.activeBenefits = new ActiveBenefits();
    }

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<unknown> {
        this.deregisterEventListeners();
        if (!this.isPresent()) {
            return;
        }
        this.htmlOffersPageLinkReplacer.initializeOffersLink();
        this.activeBenefits = new ActiveBenefits();
        this.registerBenefitEventListener();
        this.registerArticleOptionsEventListeners();

        return Promise.resolve(undefined);
    }

    private registerBenefitEventListener() {
        this.benefitsEventUnset = benefitEvents.active.subscribe(({}) => {
            this.replacePriceInHtml(this.activeBenefits.lowestActiveBenefitPrice);
        });
    }

    private replacePriceInHtml(lowestActiveBenefitPrice: BenefitPrice | undefined) {
        if (lowestActiveBenefitPrice) {
            this.findPriceElementInHtml().textContent = lowestActiveBenefitPrice.lowestPriceFormatted;
        } else {
            this.findPriceElementInHtml().textContent = this.readInitialPriceFromHtml();
        }
    }

    private readInitialPriceFromHtml() {
        const initialPrice = this.findPriceElementInHtml().getAttribute('data-initial-price');
        if (!initialPrice) {
            throw new Error('Could not find initial lowest offer price in html');
        }
        return initialPrice;
    }

    private registerArticleOptionsEventListeners() {
        o_global.eventQBus.emit(this.ARTICLE_OPTIONS_RECEIVE_SERVICE_INFORMATION_EVENT, {
            callback: (articleOptionsServices: ArticleOptionsServices) => {
                if (articleOptionsServices.services.length > 0) {
                    this.htmlOffersPageLinkReplacer.generateAndReplaceOffersPageLink(articleOptionsServices);
                }
            },
        });
        this.articleOptionsEventListener = o_global.eventQBus.on(
            this.ARTICLE_OPTIONS_CHANGED_EVENT,
            (articleOptionsServices: ArticleOptionsServices) => {
                this.htmlOffersPageLinkReplacer.generateAndReplaceOffersPageLink(articleOptionsServices);
            }
        );
    }

    private deregisterEventListeners() {
        if (this.benefitsEventUnset) {
            this.benefitsEventUnset();
        }
        if (this.articleOptionsEventListener) {
            o_global.eventQBus.off(this.ARTICLE_OPTIONS_CHANGED_EVENT, this.articleOptionsEventListener);
        }
    }

    private findPriceElementInHtml() {
        const priceElement = document.querySelector('.js_pdp_competing-offers__lowest-retail-price');
        if (!priceElement) {
            throw new Error('Failed to find price element in html');
        }
        return priceElement;
    }
}
